import { Avatar, Box } from "@mui/material";

/**
 * Componente reutilizável para labels de tabs com contador
 * Reduz repetição de código nas tabs de documentos
 */
interface TabLabelProps {
  label: string;
  count: number | string;
}

export function TabLabel({ label, count }: TabLabelProps) {
  return (
    <Box style={{ display: "flex", alignItems: "center" }}>
      {label}
      <Avatar
        sx={{
          width: 26,
          marginLeft: 1,
          height: 26,
          fontSize: "14px",
          fontWeight: 600,
          backgroundColor: "primary100.main",
          color: "primary1000.main",
        }}
      >
        {count || "0"}
      </Avatar>
    </Box>
  );
}
